class DuplicateSystem {
    constructor(basicSystemFormInstance, advancedSystemFormInstance) {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.basicSystemFormInstance = basicSystemFormInstance;
        this.advancedSystemFormInstance = advancedSystemFormInstance;
        this.duplicateSystem();
    }
    duplicateSystem(){
        const thisClass = this;
        $(document).on('click', '.duplicate-system', function(e) {
            let systemID = $(this).parent()[0].id;
            new ModalLoading();
            naja.makeRequest('GET', '/systems/?do=getSystemInfo', {
                'systemID': systemID,
                'organizationID': thisClass.organizationID
            }, {
                history: false // Prevent URL changes in browser history
            }).then(async (response) => {
                if (response) {
                    const systemTabs = document.querySelector('#create_system_modal_tabs');
                    if (response.systemInfo.isAdvanced) {
                        thisClass.advancedSystemFormInstance.fillFormWithSystemInfo(response.systemInfo);
                        bootstrap.Tab.getOrCreateInstance(systemTabs.querySelector('[href="#advance_tab"]')).show();
                    } else {
                        thisClass.basicSystemFormInstance.fillFormWithSystemInfo(response.systemInfo);
                        bootstrap.Tab.getOrCreateInstance(systemTabs.querySelector('[href="#basic_tab"]')).show();
                    }

                    KTScroll.createInstances();
                    KTMenu.createInstances();
                    const createSystemModal = document.getElementById('create_system_modal');
                    new ModalLoading(createSystemModal);

                    // Init all popovers
                    const popoverTriggerList = [].slice.call(document.querySelectorAll('#edit_system_modal [data-bs-toggle="popover"]'));
                    popoverTriggerList.map(function (popoverTriggerEl) {
                        new bootstrap.Popover(popoverTriggerEl);
                    });
                }
            }).catch(error => {
                new ModalLoading();
                toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
            });
        });
    }
}
window.DuplicateSystem = DuplicateSystem;